export const FilterArchives = (datas) => {
    const collection = [];
    const map = new Map();
    if (!datas.errno) {
        const sortDatas = (datas) => {
            datas.sort((a, b) => {
                if (a.cslug < b.cslug) return -1;
                if (a.cslug > b.cslug) return 1;
                return 0;
            });
        }
        for (const el of datas) {
            if (!map.has(el.cslug)) {
                map.set(el.cslug, true);
                collection.push({
                    cid: el.cid,
                    cslug: el.cslug,
                    cname: el.cname,
                });
            }
        }
        sortDatas(collection);
    }
    return collection;
}
